




































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Watch, Vue } from 'vue-property-decorator';
import { OrganisationService } from '@store/service/OrganisationService';
import { ErrorResponseMixin } from '@mixin';
import OrganisationForm from '@part/profile/OrganisationForm.vue';
import ProjectItem from '@part/dashboard/ProjectItem';
import UserList from '@part/organisation/UserList.vue';

/* ----------------------------------------
    Component
---------------------------------------- */

    @Component({

        data() {
            return {
                organisation: {
                    name: ''
                },
                users: [],
                projects: [],
                projectTab: 0
            };
        },

        mixins: [
            ErrorResponseMixin,
        ],

        components: {
            OrganisationForm,
            ProjectItem,
            UserList,
        },

        created() {
            this.organisationService = new OrganisationService(this.$store);
            this.enter();
        },

        methods: {
            enter() {
                this.organisationId = this.$route.params.id;
                this.fetchProject();
            },

            fetchProject() {
                this.organisationService.getOrganisation(this.organisationId).then(response => {
                    if (response instanceof Error) {
                        this.errorData = this.getErrorMessage(response);
                        return;
                    }
                    this.organisation = response.data;

                    this.organisationService.getOrganisationUsers(this.organisationId).then(organisationUsersResponse => {
                        if (organisationUsersResponse instanceof Error) {
                            this.errorData = this.getErrorMessage(organisationUsersResponse);
                            return;
                        }
                        this.users = organisationUsersResponse.data;
                    });

                    this.organisationService.getOrganisationProjects(this.organisationId).then(organisationProjectsResponse => {
                        if (organisationProjectsResponse instanceof Error) {
                            this.errorData = this.getErrorMessage(organisationProjectsResponse);
                            return;
                        }
                        this.projects = organisationProjectsResponse.data;
                    });
                });
            },

            removeUser(payload) {
                this.organisationService.removeOrganisationUser(this.organisationId, payload.userId).then(response => {
                    if (response instanceof Error) {
                        this.errorData = this.getErrorMessage(response);
                        return;
                    }

                    let user = this.users.find(userElement => userElement.id === payload.userId);
                    let updatedUserIndex = this.users.indexOf(user);
                    this.users.splice(updatedUserIndex, 1);
                });
            },

            updateUserRole(payload) {
                this.organisationService.updateOrganisationUserRole(this.organisationId, payload.userId).then(response => {
                    if (response instanceof Error) {
                        this.errorData = this.getErrorMessage(response);
                        return;
                    }

                    let user = this.users.find(userElement => userElement.id === payload.userId);
                    let updatedUserIndex = this.users.indexOf(user);
                    user.admin = !user.admin;
                    this.users.splice(updatedUserIndex, 1, user);
                });
            },
        },

        computed: {
            isAdmin() {
                return this.users.some(user => user.admin && user.id === this.authUser.data.id);
            }
        },

        watch: {
            $route() {
                this.enter();
            }
        }
    })

/* ----------------------------------------
    Export
---------------------------------------- */

export default class OrganisationAction extends Vue {}

